<template>
  <nv-model
    :id="id"
    :prev="prev"
    :next="next"
    :info="info"
    :is-rotate="isRotate90"
    :title="info.title"
    :initScale="0.5"
    @on-load="onImgLoad"
    @go="goImg"
  >
  </nv-model>
</template>

<script>
import NvModel from '@/components/ImgManager/model'

export default {
  name: 'ModalPic',
  components: { NvModel },
  props: {
    id: [Number, String],
    list: Array
  },
  data() {
    return {
      isOrig: true, // 是否使用原图
      isRotate90: false, // 缩略图是否旋转了 90 度
      info: { src: '' },
      next: null, // 下一页
      prev: null // 上一页
    }
  },
  mounted() {
    let index = this.list.findIndex(l => l.id === this.id)
    this.$nextTick(() => this.goImg(index))
  },
  methods: {
    goImg(index) {
      this.info = this.list[index]
      this.next = +index > 0 ? index - 1 : -1
      this.prev = index + 1 < this.list.length ? index + 1 : -1
    },
    onImgLoad(e) {
      this.isRotate90 = e.path[0].naturalHeight > e.path[0].naturalWidth
    },
    getStyle(item) {
      if (!this.isRotate90) {
        return {
          width: `${(item.tailPositionX - item.headPositionX) * 100}%`,
          height: `${(item.tailPositionY - item.headPositionY) * 100}%`,
          left: `${item.headPositionX * 100}%`,
          top: `${item.headPositionY * 100}%`
        }
      } else {
        return {
          width: `${(item.tailPositionY - item.headPositionY) * 100}%`,
          height: `${(item.tailPositionX - item.headPositionX) * 100}%`,
          left: `${(1 - item.tailPositionY) * 100}%`,
          top: `${item.headPositionX * 100}%`
        }
      }
    }
  }
}
</script>

<style media="screen">
.model-insect {
  position: absolute;
  border: 2px solid rgb(64, 158, 255);
}
.model-insect__name {
  font-size: 14px;
  position: absolute;
  white-space: nowrap;
  top: -20px;
  left: -4px;
}
.category-1 {
  color: rgb(255, 99, 132);
  border-color: rgb(255, 99, 132);
}
.category-2 {
  color: rgb(54, 162, 235);
  border-color: rgb(54, 162, 235);
}
.category-3 {
  color: rgb(255, 206, 86);
  border-color: rgb(255, 206, 86);
}
.category-4 {
  color: rgb(65, 184, 131);
  border-color: rgb(65, 184, 131);
}
.category-5 {
  color: rgb(204, 101, 254);
  border-color: rgb(204, 101, 254);
}
.category-6 {
  color: rgb(189, 162, 154);
  border-color: rgb(189, 162, 154);
}
</style>
